<template>
  <section id="_vid" class="video_view_area pt-100 pb-100">
    <div class="container">
      <!-- START HEADER -->
      <div class="row justify-content-left">
        <div class="col-lg-6">
          <div class="section_title text-left pb-25">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              <span style="border-top: 5px solid black"> Video </span>
            </h4>
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              TJSL KAI
            </h4>
            <span
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s">
              <p style="color: black">Galeri Video</p>
            </span>
          </div>
        </div>
      </div>
      <!-- END HEADER -->

      <!-- START CONTENT -->
      <div class="row">
        <div class="col-lg-12">

          <div class="row justify-content-center team_active">
            <div
              class="col-lg-3 col-md-5 col-sm-10 mb-10 single_blog wow fadeInUp card"
              style="margin: 30px; padding-left: 0%; padding-right: 0%"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
              v-for="(video, index) in videos"
              :key="index">
                <div>
                  <div class="zoom" style="position: relative">
                    <!-- <span class="label_video_orange">&nbsp;VIDEO&nbsp;</span> -->
                    <i
                      @click="showLightbox(video)"
                      id="play_video"
                      class="lni lni-play icon_play_video"
                      aria-hidden="true"
                      title="play"
                    ></i>
                    <img
                      style="
                        width: 100%;
                        position: relative
                      "
                      :src="
                      'https://img.youtube.com/vi/' +  video.code + '/maxresdefault.jpg'
                      "
                      @click="showLightbox(video)"/>
                        <div class="team_content">
                          <!-- <div style="position: absolute; bottom: 30%; right: 5%; z-index: 1">
                            <div class="btngroup-small">
                              <i
                                id="share_img"
                                class="lni lni-share"
                                aria-hidden="true"
                                title="share"
                                @click="showLightbox(foto)"
                                :key="foto.id"
                                style="
                                  background-color: #e7ebef;
                                  color: black;
                                  cursor: pointer;
                                  border-radius: 50px;
                                  box-shadow: 0px 0px 0px 0px black;
                                  padding: 1em 1em;
                                "
                              ></i>
                            </div>
                          </div> -->
                        <div class="two-line-overflow" style="font-size: 15px;font-weight: 600; margin: 10px">
                          <span @click="showLightbox(video)">{{ video.judul }}</span>
                          <p>
                            &nbsp;
                            <span><i class="lni lni-eye"></i>
                              {{ video.visitor_count }}
                            </span>
                            &nbsp;
                            <i class="lni lni-calendar"></i>
                            &nbsp;{{ video.waktu_upload_yt }}&nbsp;
                          </p>
                        </div>
                      </div>
                  </div>
                </div>
            </div>
          </div>


          <div class="centerBlock">
            <paginate
              v-model="page"
              :page-count=pageCount
              :click-handler="clickCallback"
              :prev-text="'Sebelumnya'"
              :next-text="'Selanjutnya'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :active-class="'myActiveBtn'"
            >
            </paginate>
          </div>
        </div>
      </div>
      <!-- END CONTENT -->
    </div>
  </section>
    <!-- CUSTOM LIGHT BOX -->
    <div>
      <ModalVideos
        :url="url"
        :indeksFromParent="index"
        :visible="visible"
        :isi="isi"
        :pembuat="pembuat"
        :waktu_buat="waktu_buat"
        @clicked="closeLightbox"
      />
    </div>
    <!-- END CUSTOM LIGHT BOX -->
</template>
<script>
import VideoDataService from "../services/VideoDataService";
import ModalVideos from "./components/ModalVideos.vue";
import Paginate from "vuejs-paginate-next";
import axios from 'axios';

export default {
  name: "videoView",
  data() {
    return {
      // videos: [],
      firstVideo: "",
      secondVideo: "",
      thirdVideo: "",
      currentIndex: -1,
      title: "",
      isOrange: false,
      lastIndex: 0,
      index: 0,
      visible: false,
      isi: "", // untuk ModalVideos
      pembuat: "", // untuk ModalVideos
      waktu_buat: "", // untuk ModalVideos
      url: "", // untuk ModalVideos

      pageCount: 0, //initial page pagination
      dataPerPage: 6, //for limiting per page
      videos: [],
      page: 1,
    };
  },
  components: {
    ModalVideos,
    paginate: Paginate,
    // VueEasyLightbox,
  },
  props: {
    visibleVideo: Boolean,
  },
  computed: {
    showVideo: {
      get() {
        return this.visibleVideo;
      },
      set(visibleVideo) {
        this.$emit("openVideoChild", visibleVideo);
      },
    },
  },
  methods: {
    
    getCountAllphotos() {
      VideoDataService.getAll(0, 999999999999999)
        .then((response) => {
          var length = response.data.data.length;
          var divided = length / this.dataPerPage;
          // var page_count = 0;
          // //jika panjang total habis dibagi dataPerPage, maka jumlah page = divided, jika masih ada sisa divided+1
          // if(length % this.dataPerPage === 0){
          //   page_count = divided;
          // }else{
          //   page_count = divided + 1;
          // }
          this.pageCount = Math.ceil(divided);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    clickCallback (pageNum) {
      console.log(pageNum-1);
      this.retrievevideos(pageNum-1, this.dataPerPage);
    },

    retrievevideos(offset, limit) {
      VideoDataService.getAll(offset, limit)
        .then((response) => {
          this.videos = response.data.data;
          console.log(this.videos);
        })
        .catch((e) => {
          console.log(e);
        });
    },


    // untuk ModalVideos
    showLightbox(data) {
      this.isi = data.isi;
      this.pembuat = data.pembuat;
      this.waktu_buat = data.waktu_buat;
      this.url = data.url;
      this.visible = true;
      this.index = 0;

      //insert visitor saat klik light box
      this.getUserAgent(data.id);
    },
    // untuk ModalVideos
    closeLightbox() {
      this.visible = false;
      this.index = 0;
      this.imagesLightBox = [];
    },
    // untuk ModalVideos
    prev(n) {
      this.index -= n;
    },
    // untuk ModalVideos
    next(n) {
      this.index += n;
    },

    getUserAgent(gv_id){
      axios
      .get("https://geolocation-db.com/json/")
      .then(response => {
        VideoDataService.sendUserAgent(
          gv_id, 
          'video',
          response.data.country_name,
          response.data.country_code,
          response.data.city,
          response.data.state,
          response.data.latitude,
          response.data.longitude,
          response.data.IPv4
        ).then((response) => {
          console.log(response.data);
          // this.currentArtikel = this.artikels[0];
          // this.currentIndex = 0;
        })
        .catch((e) => {
          console.log(e);
        });
        // this.products = response.data.products;
        // console.log(response.data.country_name);
      });
    }
  },
  mounted() {
    this.getCountAllphotos();
    this.retrievevideos(0, this.dataPerPage);
  },
};
</script>

<style>
.zoom {
  transition: transform .2s; /* Animation */
}
.zoom:hover {
  transform: scale(1.04);
  cursor: pointer;
}

.label_video_orange {
  top: 10%;
  right: 0%;
  padding: auto;
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: #f06a25;
  color: white;
  z-index: 1;
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  padding-left: 1em;
  padding-right: 1em;
  font-size: 15px;
}

.label_video_orange_small {
  top: 15%;
  right: -2%;
  padding: auto;
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: #f06a25;
  color: white;
  z-index: 1;
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  padding-left: 1em;
  padding-right: 1em;
  font-size: 11px;
}

.label_video_title {
  bottom: 0%;
  position: absolute;
  background-color: #333333;
  color: white;
  z-index: 1;
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  padding-left: 1em;
  padding-right: 1em;
  font-size: 20px;
}

.label_video_title_small {
  bottom: 0%;
  position: absolute;
  background-color: #333333;
  color: white;
  z-index: 1;
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  padding-left: 1em;
  padding-right: 1em;
  font-size: 15px;
}

.label_video_title p {
  color: white;
  font-size: 10px;
}

.label_video_title_small p {
  color: white;
  font-size: 10px;
}

.single_blog .blog_content p {
    margin-top: 1px;
}

.icon_play_video {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: #e7ebef;
  color: black;
  cursor: pointer;
  border-radius: 50px;
  box-shadow: 0px 0px 0px 0px black;
  padding: 2em 2em;
  z-index: 1;
}

.icon_play_video_small {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: #e7ebef;
  color: black;
  cursor: pointer;
  border-radius: 50px;
  box-shadow: 0px 0px 0px 0px black;
  padding: 1em 1em;
  z-index: 1;
}

.container-video {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

.container-subvideo {
  position: relative;
  overflow: hidden;
  width: 50%;
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 600px) {
  .label_video_orange {
    top: 15%;
    right: -2%;
    padding: auto;
    position: absolute;
    transform: translate(-50%, -50%);
    background-color: #f06a25;
    color: white;
    z-index: 1;
    padding-top: 0.3em;
    padding-bottom: 0.3em;
    padding-left: 1em;
    padding-right: 1em;
    font-size: 11px;
  }
  .icon_play_video {
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    background-color: #e7ebef;
    color: black;
    cursor: pointer;
    border-radius: 50px;
    box-shadow: 0px 0px 0px 0px black;
    padding: 1em 1em;
    z-index: 1;
  }

  .label_video_title {
    font-size: 80%;
  }

  .label_video_title_small {
    font-size: 80%;
  }

  .single_blog .blog_content p {
    margin-top: 1px;
  }
}

@media screen and (max-width: 990px) {
  .iframe-custom {
    height: calc(40vh - 1px);
    width: 100%;
    box-sizing: border-box;
  }
}

@media screen and (min-width: 1200px) {
  .iframe-custom {
    height: calc(20vh - 2px);
    width: calc(24vw - 4px);
    box-sizing: border-box;
  }
}

@media screen and (min-width: 1400px) {
  .iframe-custom {
    height: calc(24vh - 5px);
    width: calc(24vw - 4px);
    box-sizing: border-box;
  }
}

.zoom {
  transition: transform .2s; /* Animation */
}
.zoom:hover {
  transform: scale(1.04);
  cursor: pointer;
}

.two-line-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color:#000;
}
</style>
